import React, {useContext} from 'react'
import {PurchaseContext} from "../../../context/PurchaseContext";
import {Button} from "antd";

const DeleteRow = ({record, rowIndex}) => {
    const {purchaseItems, updateDeleteCount} = useContext(PurchaseContext)
    const [, setPurchaseList] = purchaseItems
    const [, setDeleteCount] = updateDeleteCount

    const handleDeleteClick = () => {
        setDeleteCount(oldCount => oldCount + 1)
        setPurchaseList((oldList) => {
            const mock = Object.assign([], oldList)
            mock.splice(rowIndex, 1)
            return mock
        })
    }


    return(
        <React.Fragment>
            <Button type={'link'} danger onClick={handleDeleteClick}>
                Sil
            </Button>
        </React.Fragment>
    )
}

export default DeleteRow